import React from "react";

import { CustomEventPageTargetingWrapper } from "@src/features/customEvents/components/CustomEventPageTargetingWrapper";

interface PageViewProps {
  isArchived: boolean;
}

export const PageView = ({ isArchived }: PageViewProps) => {
  return (
    <CustomEventPageTargetingWrapper
      buttonText={"Add Another URL"}
      isArchived={isArchived}
      showInitial={true}
    />
  );
};
